// tslint:disable:no-string-literal
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import * as React from 'react';
import reqwest from 'reqwest';

import ManufacturersQuery from '../../components/Query/Manufacturers';
import ManufacturerDetail from './ManufacturerDetail';
import { url } from '../../config/config';
import { Title } from '../../components/Layout/components';

interface IManufacturersTableState {
  manufacturer?: GQL.IManufacturer;
}

interface IManufacturersTableProps { }

export default class ManufacturersTable extends React.Component<IManufacturersTableProps, IManufacturersTableState> {
  constructor(props: IManufacturersTableProps) {
    super(props);
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <ManufacturersQuery>
            {({ manufacturers, deleteManufacturer, createManufacturer, updateManufacturer }: any) => {
              return this.renderData(
                manufacturers.manufacturers,
                updateManufacturer,
                createManufacturer,
                deleteManufacturer,
                manufacturers.refetch
              );
            }}
          </ManufacturersQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    manufacturers: any,
    updateManufacturer: Function,
    createManufacturer: Function,
    deleteManufacturer: Function,
    refetch: Function
  ) {
    // console.log('manufacturers', manufacturers);
    if (manufacturers) {
      return (
        <div>
          <Title>Manufacturers</Title>
          <Divider />
          <Button onClick={() => this.newManufacturer()}>Create new manufacturer</Button>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={manufacturers}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column title="Name" dataIndex="name" key="name" />
            <Table.Column title="Description" dataIndex="description" key="description" />
            <Table.Column
              width={300}
              title="Actions"
              dataIndex="actions"
              key="actions"
              render={(u: any, row: any) => this.renderActions(u, row, deleteManufacturer, refetch)}
            />
          </Table>
          {this.state &&
            this.state.manufacturer && (
              <ManufacturerDetail
                manufacturer={this.state.manufacturer}
                onSave={(a, image) =>
                  this.upsert(a, image, updateManufacturer, createManufacturer, refetch)
                }
                onCancel={() => this.setCurrentManufacturer(undefined)}
              />
            )}
          <Divider />
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading manufacturers ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, manufacturer: GQL.IManufacturer, deleteManufacturer: Function, refetch: Function) {
    return (
      <div>
        <Button type={'dashed'} onClick={() => this.setCurrentManufacturer(manufacturer)}>
          Edit
        </Button>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(manufacturer, deleteManufacturer, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private newManufacturer() {
    this.setCurrentManufacturer({
      name: '',
      description: '',
      categories: []
    });
  }

  private setCurrentManufacturer(manufacturer: any) {
    this.setState({ manufacturer });
  }

  private delete(manufacturer: GQL.IManufacturer, deleteManufacturer: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${manufacturer.name}?`,
      content: (
        <span>
          Are you sure you want to delete manufacturer <strong>{manufacturer.name}</strong>
        </span>
      ),
      onOk: () => {
        return deleteManufacturer({
          variables: {
            id: manufacturer.id
          }
        }).then(() => refetch());
      }
    });
  }

  private async upsert(
    manufacturer: GQL.IManufacturer,
    image: any,
    updateManufacturer: Function,
    createManufacturer: Function,
    refetch: Function
  ) {
    console.log({ image });
    if (manufacturer != undefined) {
      const variables = {
        id: manufacturer.id,
        manufacturer: { name: manufacturer.name, description: manufacturer.description }
      };

      if (manufacturer.id) {
        updateManufacturer({ variables })
          .then(() => this.setCurrentManufacturer(null))
          .then(() => refetch())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Manufacturer "${variables.manufacturer.name}" has been updated.`
            })
          );

        if (image && manufacturer.id) {
          console.log('uploading');
          const formData = new FormData();
          formData.append('file', image);
          reqwest({
            url: `${url}/images?manufacturerId=${manufacturer.id}`,
            method: 'post',
            processData: false,
            data: formData,
            success: () => {
              console.log('uploaded successfuly');
            },
            error: () => {
              console.log('upload failed');
            }
          });
        }

        return;
      }

      const result = await createManufacturer({ variables });
      const manufacturerId = result.data.createManufacturer.id || manufacturer.id;
      this.setCurrentManufacturer(null);
      await refetch();

      console.log({ image, manufacturerId });

      if (image && manufacturerId) {
        console.log('uploading');
        const formData = new FormData();
        formData.append('file', image);
        reqwest({
          url: `${url}/images?manufacturerId=${manufacturerId}`,
          method: 'post',
          processData: false,
          data: formData,
          success: () => {
            console.log('uploaded successfuly');
          },
          error: () => {
            console.log('upload failed');
          }
        });
      }

      notification['success']({
        message: 'Info',
        description: `Manufacturer "${variables.manufacturer.name}" has been created.`
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Manufacturers/ManufacturersTable.tsx